module.exports = __webpack_public_path__ + "static/media/catwalk .53a5fa0d.jpg";